/* eslint-disable */
import * as $protobuf from 'protobufjs/minimal';

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots['dealer.busi.ws'] || ($protobuf.roots['dealer.busi.ws'] = {});

export const apipackage = $root.apipackage = (() => {

    /**
     * Namespace apipackage.
     * @exports apipackage
     * @namespace
     */
    const apipackage = {};

    apipackage.TokenRquestBody = (function () {

        /**
         * Properties of a TokenRquestBody.
         * @memberof apipackage
         * @interface ITokenRquestBody
         * @property {string} appId TokenRquestBody appId
         * @property {string} timestamp TokenRquestBody timestamp
         * @property {string} nonceStr TokenRquestBody nonceStr
         * @property {string} userId TokenRquestBody userId
         */

        /**
         * Constructs a new TokenRquestBody.
         * @memberof apipackage
         * @classdesc socket-token请求体
         * @implements ITokenRquestBody
         * @constructor
         * @param {apipackage.ITokenRquestBody=} [properties] Properties to set
         */
        function TokenRquestBody (properties) {
            if (properties) {
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i) {
                    if (properties[keys[i]] != null) { this[keys[i]] = properties[keys[i]]; }
                }
            }
        }

        /**
         * TokenRquestBody appId.
         * @member {string} appId
         * @memberof apipackage.TokenRquestBody
         * @instance
         */
        TokenRquestBody.prototype.appId = '';

        /**
         * TokenRquestBody timestamp.
         * @member {string} timestamp
         * @memberof apipackage.TokenRquestBody
         * @instance
         */
        TokenRquestBody.prototype.timestamp = '';

        /**
         * TokenRquestBody nonceStr.
         * @member {string} nonceStr
         * @memberof apipackage.TokenRquestBody
         * @instance
         */
        TokenRquestBody.prototype.nonceStr = '';

        /**
         * TokenRquestBody userId.
         * @member {string} userId
         * @memberof apipackage.TokenRquestBody
         * @instance
         */
        TokenRquestBody.prototype.userId = '';

        /**
         * Creates a new TokenRquestBody instance using the specified properties.
         * @function create
         * @memberof apipackage.TokenRquestBody
         * @static
         * @param {apipackage.ITokenRquestBody=} [properties] Properties to set
         * @returns {apipackage.TokenRquestBody} TokenRquestBody instance
         */
        TokenRquestBody.create = function create (properties) {
            return new TokenRquestBody(properties);
        };

        /**
         * Encodes the specified TokenRquestBody message. Does not implicitly {@link apipackage.TokenRquestBody.verify|verify} messages.
         * @function encode
         * @memberof apipackage.TokenRquestBody
         * @static
         * @param {apipackage.ITokenRquestBody} message TokenRquestBody message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TokenRquestBody.encode = function encode (message, writer) {
            if (!writer) { writer = $Writer.create(); }
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.appId);
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.timestamp);
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nonceStr);
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.userId);
            return writer;
        };

        /**
         * Encodes the specified TokenRquestBody message, length delimited. Does not implicitly {@link apipackage.TokenRquestBody.verify|verify} messages.
         * @function encodeDelimited
         * @memberof apipackage.TokenRquestBody
         * @static
         * @param {apipackage.ITokenRquestBody} message TokenRquestBody message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TokenRquestBody.encodeDelimited = function encodeDelimited (message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TokenRquestBody message from the specified reader or buffer.
         * @function decode
         * @memberof apipackage.TokenRquestBody
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {apipackage.TokenRquestBody} TokenRquestBody
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TokenRquestBody.decode = function decode (reader, length) {
            if (!(reader instanceof $Reader)) { reader = $Reader.create(reader); }
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.apipackage.TokenRquestBody();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                    case 1:
                        message.appId = reader.string();
                        break;
                    case 2:
                        message.timestamp = reader.string();
                        break;
                    case 3:
                        message.nonceStr = reader.string();
                        break;
                    case 4:
                        message.userId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            if (!message.hasOwnProperty('appId')) { throw $util.ProtocolError('missing required \'appId\'', { instance: message }); }
            if (!message.hasOwnProperty('timestamp')) { throw $util.ProtocolError('missing required \'timestamp\'', { instance: message }); }
            if (!message.hasOwnProperty('nonceStr')) { throw $util.ProtocolError('missing required \'nonceStr\'', { instance: message }); }
            if (!message.hasOwnProperty('userId')) { throw $util.ProtocolError('missing required \'userId\'', { instance: message }); }
            return message;
        };

        /**
         * Decodes a TokenRquestBody message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof apipackage.TokenRquestBody
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {apipackage.TokenRquestBody} TokenRquestBody
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TokenRquestBody.decodeDelimited = function decodeDelimited (reader) {
            if (!(reader instanceof $Reader)) { reader = new $Reader(reader); }
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TokenRquestBody message.
         * @function verify
         * @memberof apipackage.TokenRquestBody
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TokenRquestBody.verify = function verify (message) {
            if (typeof message !== 'object' || message === null) { return 'object expected'; }
            if (!$util.isString(message.appId)) { return 'appId: string expected'; }
            if (!$util.isString(message.timestamp)) { return 'timestamp: string expected'; }
            if (!$util.isString(message.nonceStr)) { return 'nonceStr: string expected'; }
            if (!$util.isString(message.userId)) { return 'userId: string expected'; }
            return null;
        };

        /**
         * Creates a TokenRquestBody message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof apipackage.TokenRquestBody
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {apipackage.TokenRquestBody} TokenRquestBody
         */
        TokenRquestBody.fromObject = function fromObject (object) {
            if (object instanceof $root.apipackage.TokenRquestBody) { return object; }
            let message = new $root.apipackage.TokenRquestBody();
            if (object.appId != null) { message.appId = String(object.appId); }
            if (object.timestamp != null) { message.timestamp = String(object.timestamp); }
            if (object.nonceStr != null) { message.nonceStr = String(object.nonceStr); }
            if (object.userId != null) { message.userId = String(object.userId); }
            return message;
        };

        /**
         * Creates a plain object from a TokenRquestBody message. Also converts values to other types if specified.
         * @function toObject
         * @memberof apipackage.TokenRquestBody
         * @static
         * @param {apipackage.TokenRquestBody} message TokenRquestBody
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TokenRquestBody.toObject = function toObject (message, options) {
            if (!options) { options = {}; }
            let object = {};
            if (options.defaults) {
                object.appId = '';
                object.timestamp = '';
                object.nonceStr = '';
                object.userId = '';
            }
            if (message.appId != null && message.hasOwnProperty('appId')) { object.appId = message.appId; }
            if (message.timestamp != null && message.hasOwnProperty('timestamp')) { object.timestamp = message.timestamp; }
            if (message.nonceStr != null && message.hasOwnProperty('nonceStr')) { object.nonceStr = message.nonceStr; }
            if (message.userId != null && message.hasOwnProperty('userId')) { object.userId = message.userId; }
            return object;
        };

        /**
         * Converts this TokenRquestBody to JSON.
         * @function toJSON
         * @memberof apipackage.TokenRquestBody
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TokenRquestBody.prototype.toJSON = function toJSON () {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TokenRquestBody;
    })();

    return apipackage;
})();

export { $root as default };
